// import logo from './logo.svg';
import './App.css';
import CreditCardOptimizer from './CreditCardOptimizer';

function App() {
  return (
    <div className="App">
      <CreditCardOptimizer />
    </div>
  );
}

export default App;
